import { ReactElement } from 'react'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'

interface ItemProps {
  text: string
  action?: () => void
}

const Item = (props: ItemProps): ReactElement => {
  const { text, action } = props
  return (
    <BreadcrumbText {...(action && { clickable: true, onClick: action })}>
      {text}
    </BreadcrumbText>
  )
}

interface ItemI {
  clickable?: boolean
}

const BreadcrumbText = styled.span<ItemI>`
  font-family: 'Oswald';
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  color: ${defaultTheme.colors.primaryText};
  cursor: ${(p) => (p.clickable ? 'pointer' : 'auto')};
`

export default Item
